import { ruleWrapMode } from './alignment';
import type { GridDataFormat, ColumnAlign, ColumnWrapMode } from './formats';
import type { CellRule, CellType, GridAlignment } from './types';

/** Resolve headings against the document's settings, independently of its viewer. */
export function resolveHeaderRule(
  format: GridDataFormat | undefined,
  defaults: GridAlignment,
  cellType: CellType,
  cellAlign?: ColumnAlign,
  cellWrap?: ColumnWrapMode,
): CellRule {
  const fallback = defaults.header;
  if (format?.headerMode === 'same') {
    const cell = defaults[cellType];
    const align = format.align ?? cellAlign;
    const wrapMode = format.wrapMode ?? cellWrap ?? ruleWrapMode(cell, cellType);
    return { ...cell, align: align && align !== 'auto' ? align : cell.align, wrapMode, wrap: wrapMode === 'wrap' };
  }
  if (format?.headerMode === 'custom') {
    const align = format.headerAlign;
    const wrapMode = format.headerWrapMode ?? (fallback.wrapMode ?? (fallback.wrap ? 'wrap' : 'clip'));
    return { ...fallback, align: align && align !== 'auto' ? align : fallback.align, wrapMode, wrap: wrapMode === 'wrap' };
  }
  return fallback;
}
